export enum SyncMarketplaceResourcesEnum {
  PROJECT = 'project',
  MODEL = 'model',
  UNIT = 'unit',
  UNITS_BY_PROJECT = 'units-by-project',
  MODELS_BY_PROJECT = 'models-by-project',
  AVAILABLE_UNITS_BY_PROJECT = 'available-units-by-project',
  PROPERTY = 'property',
}
